import axios from 'axios';

import { refreshAccessToken } from './authService';

import { environment } from '../config/environment';


const axiosInstance = axios.create({

  baseURL: environment.apiUrl

});


const AUTH_ROUTES = [

  '/auth/login',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/verify-otp',
  '/auth/refresh-token',
  '/auth/validate-token'

];

const PUBLIC_ROUTES = [
  '/user/confirm-account'
];

const isAuthRoute = (url = '') =>
  AUTH_ROUTES.some(route => url.startsWith(route));

const IsPublicRoute = (url = '') =>
  PUBLIC_ROUTES.some(route => url.includes(route))


axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};


    if (!isAuthRoute(config.url)) {
      config.url = `/api${config.url}`;

    }

    if (isAuthRoute(config.url)) return config;

    if (IsPublicRoute(config.url)) return config;

    const token = localStorage.getItem('bgc_token');
    const email = localStorage.getItem('user_email');

    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (email) config.headers['X-User'] = email;

    return config;
  },
  (error) => Promise.reject(error)
);



axiosInstance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (isAuthRoute(originalRequest?.url)) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('bgc_refresh_token');

        if (!refreshToken) throw new Error();

        const { accessToken } = await refreshAccessToken(refreshToken);
        localStorage.setItem('bgc_token', accessToken);
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;

        return axiosInstance(originalRequest);
      } catch (e) {
        localStorage.clear();
        window.location.href = '/';

      }
    }
    return Promise.reject(error);
  }

);
export default axiosInstance;

